import graphql from "babel-plugin-relay/macro";

import {
  WhooshMutationError,
  useMutationWithError,
} from "../../../../../utils/hooks/useMutationWithError";
import {
  UpdateMemberUserInput,
  useUpdateMemberUserMutation,
} from "./__generated__/useUpdateMemberUserMutation.graphql";

export const useUpdateMemberUser = (
  callback: () => void,
  onError?: (errors: any) => void
) => {
  const [updateMemberProfile, isUpdating] =
    useMutationWithError<useUpdateMemberUserMutation>(ProfileUpdateFormGql);

  const handleUpdateMemberUser = (input: UpdateMemberUserInput) => {
    updateMemberProfile({
      variables: { input },
      onCompleted: () => {
        callback();
      },
      onCompletedErrorCustom: (errors: WhooshMutationError[]) => {
        onError?.(errors);
        return errors;
      },
    });
  };
  return [handleUpdateMemberUser, isUpdating] as const;
};

export const ProfileUpdateFormGql = graphql`
  mutation useUpdateMemberUserMutation($input: UpdateMemberUserInput!) {
    responsePayload: updateMemberUser(input: $input) {
      user {
        id
        firstName
        lastName
        phoneNumber {
          nationalNumber
        }
      }
      success
      errors {
        code

        message
        field
      }
    }
  }
`;
